import React from 'react';
import { Layers } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  emptyContainer: {
    padding: '32px 16px',
    textAlign: 'center',
  },
  emptyIcon: {
    fontSize: '48px',
    color: 'rgba(156, 163, 175, 0.5)', // text-muted-foreground/50 equivalent
    margin: '0 auto 12px auto',
    display: 'block',
  },
  emptyText: {
    fontSize: '14px',
    color: '#6b7280', // text-muted-foreground equivalent
    margin: 0,
  },
}));

/**
 * Component for displaying an empty state with icon and text
 * @param {Object} props - The component properties
 * @param {React.ReactNode} props.children - The content to display
 * @param {import('@material-ui/icons').SvgIconComponent} Icon - The icon component to display
 * @returns {JSX.Element} The Empty component
 */
export default function Empty({ children, Icon = Layers }) {
  const classes = useStyles();
  return (
    <div className={classes.emptyContainer}>
      <Icon className={classes.emptyIcon} />
      <div className={classes.emptyText}>{children}</div>
    </div>
  );
}

Empty.propTypes = {
  /** The content to display */
  children: PropTypes.node,
};
